  <h2 mat-dialog-title>Send Push Notification</h2>
  <mat-dialog-content fxLayout='column'>
    <mat-form-field style='width:100%'>
      <mat-label>From</mat-label>
      <input matInput placeholder='From' [(ngModel)]='sender'>
    </mat-form-field>
    <mat-form-field>
      <mat-label>Message</mat-label>
      <textarea matInput matTextareaAutosize matAutosizeMinRows="10" matAutosizeMaxRows="15" placeholder='Message' [(ngModel)]='message'></textarea>
    </mat-form-field>
  </mat-dialog-content>
  <mat-dialog-actions>
    <button mat-raised-button color='accent' (click)="send()" tabindex="2">Send it
        <i *ngIf='sending' class='fa fa-spinner fa-spin fa-fw'></i>
      </button>
      <button mat-button mat-dialog-close tabindex="-1">Nevermind</button>
  </mat-dialog-actions>